import { render, staticRenderFns } from "./IconSVG.vue?vue&type=template&id=30053e36&"
import script from "./IconSVG.vue?vue&type=script&lang=js&"
export * from "./IconSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30053e36')) {
      api.createRecord('30053e36', component.options)
    } else {
      api.reload('30053e36', component.options)
    }
    module.hot.accept("./IconSVG.vue?vue&type=template&id=30053e36&", function () {
      api.rerender('30053e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconSVG.vue"
export default component.exports